/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { MENU_SECTIONS } from '../constants/menuSections';

export function getMenuSections() {
    return MENU_SECTIONS;
}
